/**
* DevExpress Dashboard (_format-rules-common.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { FormatConditionBarOptions } from '../conditions/format-condition-bar-options';
export const negativeInfinity = '-Infinity';
export let fieldTypes = {
    Text: 'System.String',
    DateTime: 'System.DateTime',
    Bool: 'System.Boolean',
    Integer: 'System.Int32',
    Float: 'System.Single',
    Double: 'System.Double',
    Decimal: 'System.Decimal',
    Enum: 'Enum',
    Custom: 'Custom',
    Unknown: 'Unknown'
};
export let complexValueType = { propertyName: 'type', modelName: '@Type', defaultVal: null };
export let complexValuePersistedValue = { propertyName: '_persistedValue', modelName: '@Value', defaultVal: null };
export let complexValueValue = { propertyName: 'value' };
export let complexValueInfo = [complexValueType, complexValueValue, complexValuePersistedValue];
export let styleSettings = { propertyName: 'styleSettings', displayName: 'DashboardWebStringId.StyleSettings' };
export let barOptions = { propertyName: 'barOptions', modelName: 'BarOptions', displayName: 'DashboardWebStringId.ConditionalFormatting.BarOptions', type: FormatConditionBarOptions };
